"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _courseDeclare = require("@/api/courseDeclare/courseDeclare");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _school = require("@/api/school/school");
var _player = require("@/api/player/player");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      isLoad: false,
      backreason: "",
      isAudit: false,
      studentList: [{
        name: "",
        mobile: "",
        email: "",
        idCard: ""
      }],
      //添加参赛选手
      teacherList: [{
        name: "",
        mobile: "",
        email: "",
        indexNum: 1,
        idCard: ""
      }],
      //添加指导教师
      applyDia: false,
      causeDia: false,
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "matchName",
        placeholder: "名称"
      }
      // {
      //   label: "报名状态",
      //   type: "select",
      //   model: "status",
      //   options: [
      //     { name: "未报名", value: 0 },
      //     { name: "已报名", value: 1 },
      //   ],
      //   placeholder: "报名状态",
      // },
      ],
      modelData: {
        matchName: ""
        // status: "",
      },
      defaultColumn: [{
        name: "项目名称",
        prop: "matchName",
        isShow: true,
        width: "200"
      }, {
        name: "项目类型名称",
        prop: "matchTypeName",
        isShow: true,
        width: "200"
      }, {
        name: "项目开始时间",
        prop: "startTime",
        isShow: true,
        width: "200"
      }, {
        name: "项目结束时间",
        prop: "endTime",
        isShow: true,
        width: "200"
        // isFormats: true,
      }],
      funBtns: [],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [
        // { name: "报名fff", class: "editor", option: "signUp", span: 5 },
        // {
        //   name: "查看退回原因",
        //   class: "editor",
        //   option: "viewReason",
        //   span: 5,
        //   field: {
        //     name: "status",
        //     value: 5,
        //   },
        // },
        // {
        //   name: "查看审核进度",
        //   class: "editor",
        //   option: "showauditbackjindu",
        //   span: 3,
        // },
      ],
      formatters: {
        status: [{
          name: "未提交",
          value: -1
        }, {
          name: "草稿",
          value: 0
        }, {
          name: "学校待审核",
          value: 1
        }, {
          name: "市级管理员待审核",
          value: 2
        }, {
          name: "项目管理员待审核",
          value: 3
        }, {
          name: "审核成功",
          value: 4
        }, {
          name: "已退回",
          value: 5
        }]
      },
      sort: {
        prop: "",
        order: ""
      },
      school: {
        bureauId: "",
        queryValue: "",
        type: 0
      },
      idList: [],
      checkBoxList: [],
      checkBoxs: [],
      //
      applyInfo: {
        id: "",
        matchId: "",
        majorId: "",
        majorName: "",
        matchName: "",
        matchTypeId: "",
        matchTypeName: "",
        partyInfoId: "",
        studentList: [],
        teacherList: [],
        status: "",
        idCard: ""
      },
      tuihuiquery: {
        id: ""
      },
      // 查看审核进度参数
      showauditbackquery: {
        id: ""
      },
      showauditbackList: [],
      showauditback: false,
      rules: [],
      applyType: "",
      listQuery: {
        matchName: "",
        pageNum: 1,
        pageSize: 10
      },
      projectList: []
    };
  },
  methods: {
    //进入申报列表
    openList: function openList(e) {
      console.log('99999', e);
      this.$router.push({
        path: "/courseDeclare/declareList",
        query: {
          id: e.id,
          item: e
        }
      });
    },
    //获取项目列表
    getjiangsuMatchList: function getjiangsuMatchList() {
      var _this = this;
      (0, _courseDeclare.jiangsuMatchList)(this.listQuery).then(function (res) {
        var data = res.data;
        console.log('jjjj', data);
        if (res.code == 2000) {
          _this.totalData = data.total;
          _this.listData = data.list;
        }
      });
    },
    // quxiao
    backSubmit: function backSubmit() {
      this.applyDia = false;
      this.isLoad = false;
    },
    handleClose: function handleClose() {
      this.showauditback = false;
    },
    // 查看退审原因
    showauditbackjindu: function showauditbackjindu(e) {
      console.log(e.id);
      this.showauditbackquery.id = e.partyInfoId;
      this.showauditback = true;
      this.getPartyLogList();
    },
    getPartyLogList: function getPartyLogList() {
      var _this2 = this;
      (0, _school.getPartyLogList)(this.showauditbackquery).then(function (res) {
        var data = res.data;
        console.log(data);
        if (res.code == 2000) {
          _this2.showauditbackList = res.data;
        }
      });
    },
    // 报名
    signUp: function signUp(e) {
      this.applyType = e.partyType;
      //未提交、草稿、退回状态时可显示提交按钮
      if (e.status != 0 && e.status != -1 && e.status != 5) {
        this.isAudit = true;
      } else {
        this.isAudit = false;
      }
      if (e.partyInfoId !== null) {
        // 调用记录接口
        this.getAplyInfo(e.partyInfoId);
      } else {
        this.applyInfo = e;
        this.applyInfo.studentList = [], this.applyInfo.teacherList = [], this.studentList = [{
          name: "",
          mobile: "",
          email: ""
        }];
        this.teacherList = [{
          name: "",
          mobile: "",
          email: "",
          indexNum: 1
        }];
        this.applyInfo.matchId = e.id;
      }
      this.applyDia = true;
    },
    // 提交
    submitApply: function submitApply(e) {
      var _this3 = this;
      this.applyInfo.studentList = this.studentList;
      this.applyInfo.teacherList = this.teacherList;
      this.applyInfo.status = e;
      this.isLoad = true;
      (0, _player.subMitApply)(this.applyInfo).then(function (res) {
        _this3.$message.success("操作成功。");
        _this3.applyDia = false;
        _this3.isLoad = false;
        _this3.getjiangsuMatchList();
      });
    },
    // 获取报名表详情
    getAplyInfo: function getAplyInfo(e) {
      var _this4 = this;
      (0, _player.getApplyInfo)({
        id: e
      }).then(function (res) {
        var data = res.data;
        _this4.applyInfo = data;
        _this4.studentList = _this4.applyInfo.studentList;
        _this4.teacherList = _this4.applyInfo.teacherList;
      });
    },
    // 删除教师
    delTeacher: function delTeacher(e, j) {
      this.teacherList.splice(j, 1);
      this.teacherList.forEach(function (i, j) {
        i.indexNum = j + 1;
      });
    },
    // 删除选手
    delPlayer: function delPlayer(e, j) {
      this.studentList.splice(j, 1);
    },
    // 新增教师
    addTeacher: function addTeacher(e, j) {
      var v = this.teacherList.length;
      // 团体赛限制
      if (this.applyType == 2) {
        if (v >= 2) {
          this.$message.error("团体赛项目指导教师最多为两人。");
          return false;
        } else {
          this.teacherList.push({
            name: "",
            tel: "",
            email: "",
            indexNum: this.teacherList.length + 1,
            idCard: ""
          });
        }
        // 个人赛限制
      } else if (this.applyType == 1) {
        if (v >= 1) {
          this.$message.error("个人赛项目指导教师最多为一人。");
          return false;
        } else {
          this.teacherList.push({
            name: "",
            tel: "",
            email: "",
            indexNum: this.teacherList.length + 1,
            idCard: ""
          });
        }
      }
    },
    // 新增选手
    addPlayer: function addPlayer(e) {
      this.studentList.push({});
    },
    search: function search(val) {
      // listQuery:{
      //   matchName: "",
      //   pageNum: 1,
      //   pageSize: 10
      // },
      console.log('pp', val);
      this.listQuery.matchName = val.matchName;
      this.getjiangsuMatchList();
    },
    // 查看退回原因
    viewReason: function viewReason(val) {
      this.causeDia = true;
      this.tuihuiquery.id = val.partyInfoId;
      this.getExitReasonById();
    },
    // 退回原因接口
    getExitReasonById: function getExitReasonById() {
      var _this5 = this;
      (0, _player.getExitReasonById)(this.tuihuiquery).then(function (res) {
        console.log(res);
        _this5.backreason = res.data;
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getjiangsuMatchList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getjiangsuMatchList();
    }
  },
  created: function created() {
    this.getjiangsuMatchList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};